var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"hg-es-widget-app200210"}},[_c('events-view',{attrs:{"accessToken":_vm.token}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }